<template>
	<div class="infoCollection">
		<div class="container">
			<div class="title">{{ lang.InvestmentCooperation }}</div>

			<div class="infoCollection-bar">
				<div class="infoCollection-item">
					<div class="infoCollection-content">
						<div class="infoCollection-label">{{ lang.InformationCollectionForm }}</div>
						<div class="infoCollection-desc">{{ lang.InformationCollection_text1 }}<span style="color: #FBC42B;"> *
							</span>{{ lang.InformationCollection_text2 }}</div>
					</div>
				</div>

				<div class="form-container">
					<div class="info-tip">
						<div class="info-tip-bg">
							<img src="../../assets/infoCollection_icon.png" alt="" />
							<span style="display: inline-block;">{{ lang.Multiple_choice_text1 }}<span style="font-weight: bold;">{{
								lang.Multiple_choice }}</span>{{ lang.Multiple_choice_text2 }}</span>
						</div>
					</div>
					<el-form :model="formData" :rules="rules" ref="infoForm" label-position="top">
						<el-table :data="[formData]" border class="info-table" header-row-class-name="table-header"
							v-if="!isMobile">
							<el-table-column width="180">
								<template slot="header">
									<span>{{ lang.name }}</span>
									<span style="color: #FBC42B; margin-left: 2px;">*</span>
								</template>
								<template slot-scope="scope">
									<el-form-item prop="name">
										<el-input v-model="scope.row.name" :placeholder="lang.name_text" size="small"></el-input>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column width="300">
								<template slot="header">
									<span>{{ lang.phone }}</span>
									<span style="color: #FBC42B; margin-left: 2px;">*</span>
								</template>
								<template slot-scope="scope">
									<el-form-item prop="contact">
										<area-code ref="areaCodeRef" @phoneNumberChange="changePhone" :key="'areaCodeRef'"
											@countryChange="changeCountry"></area-code>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column :label="lang.companyName" width="180">
								<template slot-scope="scope">
									<el-form-item>
										<el-input v-model="scope.row.company" :placeholder="lang.companyName_text" size="small"></el-input>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column :label="lang.address" min-width="200">
								<template slot-scope="scope">
									<el-form-item>
										<el-input v-model="scope.row.address" :placeholder="lang.address_text" size="small"></el-input>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column :label="lang.purchaser + '/' + lang.supplier" width="200">
								<template slot-scope="scope">
									<el-checkbox :label="lang.purchaser" v-model="formData.purchaser"></el-checkbox>
									<el-checkbox :label="lang.supplier" v-model="formData.supplier"></el-checkbox>
								</template>
							</el-table-column>
						</el-table>
						<el-card shadow="never" v-else>
							<el-form-item :label="lang.name" label-width="80px" prop="name">
								<el-input v-model="formData.name" :placeholder="lang.name_text" size="small"></el-input>
							</el-form-item>
							<el-form-item :label="lang.phone" label-width="80px" prop="contact">
								<area-code ref="areaCodeMobileRef" key="areaCodeMobileRef" @phoneNumberChange="changePhone"
									@countryChange="changeCountry"></area-code>
							</el-form-item>
							<el-form-item :label="lang.companyName" label-width="80px" prop="company">
								<el-input v-model="formData.company" :placeholder="lang.companyName_text" size="small"></el-input>
							</el-form-item>
							<el-form-item :label="lang.address" label-width="80px" prop="address">
								<el-input v-model="formData.address" :placeholder="lang.address_text" size="small"></el-input>
							</el-form-item>
							<el-form-item :label="lang.purchaser + '/' + lang.supplier" label-width="80px">
								<el-checkbox :label="lang.purchaser" v-model="formData.purchaser"></el-checkbox>
								<el-checkbox :label="lang.supplier" v-model="formData.supplier"></el-checkbox>
							</el-form-item>
						</el-card>

						<div class="form-actions" :style="{ justifyContent: isMobile ? 'center' : 'flex-end' }">
							<el-button @click="resetForm" style="color: #18813C;" icon="el-icon-refresh-right">{{ lang.reset
							}}</el-button>
							<el-button style="background: #18813C;color: #FFFFFF;" @click="submitForm">
								<img src="@/assets/reset-icon.png" alt="">
								{{ lang.submit }}
							</el-button>
						</div>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { saveInfoCollect } from "@/api/index";
import areaCode from "@/components/areaCode";
export default {
	name: "infoCollection",
	computed: {
		...mapState({
			lang: state => state.user.lang,
		})
	},
	data() {
		return {
			isMobile: false,
			// 自定义断点
			mobileBreakpoint: 768,
			areaCode: {},
			formData: {
				name: '',
				contact: '',
				company: '',
				address: '',
				purchaser: true,
				supplier: false
			},
			rules: {
				name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' }
				],
				contact: [
					{ required: true, message: '请输入联系方式', trigger: 'blur' },
				]
			},
		}
	},
	components: {
		areaCode
	},

	mounted() {
		this.areaCode = {
			name: this.lang.China,
			code: '+86',
			emoji: '🇨🇳',
			pattern: /^1[3-9]\d{9}$/
		}
		this.rules.name[0].message = this.lang.name_text;
		this.rules.contact[0].message = this.lang.phone_text1;
		this.checkDevice()
		window.addEventListener('resize', this.checkDevice)
	},
	methods: {
		changePhone(e) {
			this.formData.contact = e
		},
		changeCountry(e) {
			this.areaCode = e
		},
		// 检测设备类型
		checkDevice() {
			this.isMobile = window.innerWidth <= this.mobileBreakpoint
		},
		resetForm() {
			this.$refs.infoForm.resetFields();
			this.formData = {
				name: '',
				contact: '',
				company: '',
				address: '',
				purchaser: true,
				supplier: false
			};
			if (this.isMobile) {
				this.$refs.areaCodeMobileRef.phoneNumber = ''
			} else {
				this.$refs.areaCodeRef.phoneNumber = ''
			}
		},
		submitForm() {
			const {
				name,
				contact,
				company,
				address,
				purchaser,
				supplier
			} = this.formData;
			this.$refs.infoForm.validate((valid) => {
				if (valid) {
					let typeArr = []
					const isValid = this.areaCode.pattern.test(contact)
					if (!isValid) {
						this.$message.error(this.lang.phone_text2);
						return
					}
					if (purchaser) {
						typeArr.push(1)
					}
					if (supplier) {
						typeArr.push(2)
					}
					let data = {
						name,
						phoneNum: this.areaCode.code + ' - ' + contact,
						companyName: company,
						address,
						type: typeArr,
					}
					saveInfoCollect(data).then(res => {
						if (res.code == 200) {
							this.$message.success(this.lang.submit_text1);
							this.resetForm()
						}
					})
				} else {
					this.$message.error(this.lang.submit_text2);
					return false;
				}
			});
		},
	}
}
</script>

<style lang='less'>
.table-header th {
	color: #ffffff;
	background-color: #00A53C !important;

	div {
		text-align: center;
	}
}

// 修改复选框选中状态的颜色
.el-checkbox__input.is-checked .el-checkbox__inner {
	background-color: #00A53C !important; // 背景色改为 #00A53C
	border-color: #00A53C !important; // 边框色改为 #00A53C
}

// 修改复选框选中后，文字标签的颜色（可选，保持视觉一致）
.el-checkbox__input.is-checked+.el-checkbox__label {
	color: #00A53C !important;
}

// 修改复选框获取焦点时的边框颜色（可选，提升交互体验）
.el-checkbox__input.is-focus .el-checkbox__inner {
	border-color: #00A53C !important;
}

.infoCollection {
	width: 100%;
	min-height: 100vh;
	padding: 4rem 0;
	background: linear-gradient(to top, #E6F8ED, #ffffff);
	background-repeat: no-repeat;
	display: flex;
	justify-content: center;
	align-items: center;

	.container {
		width: 90%;
		max-width: 1200px;
		margin: 0 auto;
		border-radius: 24px;

		.title {
			font-size: 2rem;
			font-weight: bold;
			color: #333;
			margin-bottom: 0.5rem;
      text-align: center;
      height: 100px;
		}

		.subtitle {
			font-size: 1rem;
			color: #666;
			margin-bottom: 3rem;
		}

		.infoCollection-bar {
			margin-bottom: 1rem;

			.infoCollection-item {
				min-height: 166px;
				background: linear-gradient(to right, #008637, #00D76B);
				border-radius: 24px 24px 0 0;

				.infoCollection-content {
   				min-height: 166px;
					padding: 40px;
					background: url('../../assets/bg_icon.png') 50% 50%;

					.infoCollection-label {
						color: white;
						font-weight: bold;
						font-size: 24px;
						margin-bottom: 10px;
					}

					.infoCollection-desc {
						color: white;
						font-size: 16px;
					}

				}
			}

			.form-container {
				background-color: white;
				padding: 2rem;
				border-radius: 0 0 24px 24px;
				box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

				.info-tip {
					width: 100%;
					margin: 1rem 0;
					background-color: #00A438;
					border-radius: 8px;
					display: flex;
					justify-content: flex-end;

					.info-tip-bg {
						width: 99%;
						padding: 10px 1rem;
						display: flex;
						border-radius: 8px;
						justify-content: flex-start;
						align-items: center;
						color: #0D663F;
						background-color: #F0FEF5;
					}

					img {
						margin-right: 10px;
					}
				}

				.info-table {
					width: 100%;

					::v-deep .el-form-item {
						margin-bottom: 0;
					}

					::v-deep .el-input__inner {
						border: 1px solid #d9d9d9;

						&:focus {
							border-color: #00A53C;
						}
					}

				}

				.form-actions {
					margin-top: 2rem;
					display: flex;
					justify-content: flex-end;

					.el-button {
						padding: 10px 30px;
						margin-left: 10px;
					}
				}
			}
		}
	}
}

// @media (min-width: 1221px) {
// 	.container {
// 		.infoCollection-bar {
// 			.form-container {
// 				overflow-x: auto;
// 			}
// 		}
// 	}
// }

@media (max-width: 1220px) {
	.infoCollection {
		padding: 2rem 0;
	}

	.container {
		width: 95%;

		.title {
			font-size: 1.5rem;
		}

		.infoCollection-bar {
			.infoCollection-item {
				.infoCollection-content {
					padding: 20px;

					.infoCollection-label {
						font-size: 1.2rem;
					}

					.infoCollection-desc {
						font-size: 0.9rem;
					}
				}
			}

			.form-container {
				padding: 1.5rem;
			}
		}
	}
}

@media (max-width: 768px) {
	.container {
		.infoCollection-bar {
			.form-container {
				overflow-x: auto;

				.info-tip {
					.info-tip-bg {
						width: 95%;
					}
				}
			}

		}
	}
}
</style>